<div class="loginWrap">

    <div class="leftPanel">
        <h2>Welcome to<br/>rail e-learning</h2>
        <div class="loginNav">
            <a href="javascript:void(0);">Privacy Policy</a>
            <a href="javascript:void(0);">Terms of Services</a>
            <a href="javascript:void(0);">Contact Us</a>
        </div>
    </div>
    <div class="rightPanel">
        <div class="loginContent">
            <h1 [routerLink]="['/']"><img src="assets/images/logo.svg" /> </h1>
            <form [formGroup]="forgetPasswordForm">
                <div class="form-group">
                    <input type="email" class="form-control" formControlName="email" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Enter Email ID" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" >
                    <div *ngIf="submitted && f.email.errors">
                        <span *ngIf="f.email.errors.required" class="text-mute text-danger errorText">This field is required</span>
                        <span *ngIf="f.email.errors.pattern" class="text-mute text-danger errorText">Please provide a valid email address</span>
                    </div>
                    <div *ngIf="submitted && !f.email.errors && errorInfo.isError == true">
                        <span  class="text-mute text-danger errorText">Email not Exist</span>
                    </div>
                </div>
                <div class="d-block text-center">
                <button *ngIf="status==1" type="submit" class="btn btn-link second-link d-inline-block" [routerLink]="['/']" >Cancel</button>
                <button *ngIf="status==2" type="submit" class="btn btn-link second-link d-inline-block" [routerLink]="['/admin-login']" >Cancel</button>
                <button type="submit" class="btn btn-primary d-inline-block" (click)="forgetPass(forgetPasswordForm.value)" >Send Link & Password</button>
               
            </div> 
              </form>
        </div>
        <div class="beforeContact">
            Do not have login and wish to get one? <a href="">Contact us</a> with your details
        </div>
        <input type="hidden" (click)="open(suucessForget)" id="successMsg">
    </div>
    
    <div class="loginNav mobileNave">
        <a href="javascript:void(0);">Privacy Policy</a>
        <a href="javascript:void(0);">Terms of Services</a>
        <a href="javascript:void(0);">Contact Us</a>
    </div>
</div>
<!--success pop for foget password-->
<ng-template #suucessForget let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <p class="size18">{{suucessMsgForget}}</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')" class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>
<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>
